export default "__VITE_ASSET__BwyxXmKG__"